import { apolloClient } from '@/vue-apollo'
import { Preferences } from '@capacitor/preferences';
import gql from 'graphql-tag'
import { defineStore } from 'pinia'

export const useBrandStore = defineStore('brandStore', {
  state: ()=> ({
    isAuthenticated: false,
    isLoading: false,
    error: null,
    brand: <any>{
      id:'',
      avatar:'',
      name:'',
      description:'',
      details:'',
      products: <any>[],
      reviews:<any>[]
    },
    brands: <any>[],
    searchHistory: <string[]>[]
  }),
  actions: {
    async axBrands(searchQuery = '') {
      this.isLoading = true;
      try {
        const response = await apolloClient.query({
          variables: {
            title: searchQuery,
          },
          query: gql`
            query brands($title: String!) {
              brands(title: $title) {
                id
                logo
                website
                name
                description
                reviews {
                  rating
                }
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        if (response.data.brands) {
          this.brands = response.data.brands;
          this.isLoading = false;
          return true
        } else {
          this.brands = [];
          this.isLoading = false;
          return false
        }
        
      } catch (error) {
        this.isLoading = false;
        this.brands = [];
      }
    },
    
    async axBrand(id: any) {
        this.isLoading = true;
        const response = await apolloClient.query({
          variables: {
            id,
          },
          query: gql`
            query brand($id: String!) {
              brand(id: $id) {
                id
                logo
                website
                name
                description
                products {
                  id
                  url
                  title
                  rating
                  description
                  category {
                    title
                  }
                  reviews {
                    id
                    title
                    description
                    rating
                  }
                }
                reviews {
                  id
                  title
                  description
                  rating
                  updatedAt
                  user {
                    firstName
                    lastName
                  }
                }
                locations {
                  location {
                    name
                    logo
                    type
                    website
                  }
                }
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        if (response.data.brand) {
          this.brand = response.data.brand;
          this.isLoading = false;
          return true
        } else {
          this.brand = null;
          this.isLoading = false;
          return false
        }
    },

    async axCreateBrand(data: any) {
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data,
          },
          mutation: gql`
            mutation createBrand($data: BrandInput) {
              createBrand(data: $data) {
                id
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        console.log('resCreateBrand===>', response)
        if (response.data.createBrand.id) {
          this.isLoading = false;
          return response.data.createBrand?.id;
        } else {
          this.isLoading = false;
          return null
        }
      } catch (error) {
        this.isLoading = false;
        return null;
      }
    },

    async axCreateSuggestBrand(data: any) {
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data,
          },
          mutation: gql`
            mutation createSuggestedBrand($data: SuggestedBrandInput) {
              createSuggestedBrand(data: $data) {
                id
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        console.log('resCreateSuggestBrand===>', response)
        if (response.data.createSuggestedBrand.id) {
          this.isLoading = false;
          return true
        } else {
          this.isLoading = false;
          return false
        }
      } catch (error) {
        this.isLoading = false;
        return false;
      }
    },

    async axSetHistoryToStorage(history: string) {
      const temp = new Set([history, ...this.searchHistory]);
      this.searchHistory = [...temp];
      console.log("searchHistory01==>", this.searchHistory);
      await Preferences.set({
        key: 'brandHistory',
        value: this.searchHistory.toString(),
      })
    },

    async axSetHistoryToState() {
      try {
        const history = await Preferences.get({ key: 'brandHistory' });
        this.searchHistory = (history.value)?.split(",") || [];
      } catch (error) {
        console.log(error)
      }
    },
  },

})